module.exports = __webpack_public_path__ + "media/images/front/hospitals/teikyo-a7bd322a11d374fafcb9e0abd5852833.jpg";